import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './http'
import tool from '../static/js/tool'
import ElementUI from 'element-ui'
Vue.use(ElementUI)
import md5 from 'js-md5'
import scroll from 'vue-seamless-scroll'
import Collection from './views/personal/Collection';
import Viewer from 'v-viewer'
import {setCookie,getCookie,checkCookie,delCookie} from '../utils/cookie.js';
// 图片浏览插件
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
import htmlToPdf from './htmlToPdf'
import axios from 'axios'
import '../static/css/reset.css'
import '../static/css/swiper.css'
import '../static/fonts/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
axios.defaults.withCredentials = false;
Vue.prototype.$axios = axios
Vue.prototype.$md5 = md5
Vue.prototype.$tool = tool
Vue.prototype.$http = http
Vue.prototype.$upload = 'http://cyteam.org.cn/api/v1/file/files'
Vue.prototype.$jump = function (url) {
  this.$router.push({
    name: url
  })
}
Vue.prototype.$jParams = function (url, parameters) {
  this.$router.push({
    name: url,
    params: parameters
  })
}
Vue.prototype.$jP = function (url, queryters) {
  if (!sessionStorage.id) {
    this.$alert("请先登录！", "提示", {
       confirmButtonText: "确定",
       callback: action => {}
     });
     setTimeout(() => {
      this.$jump('login');
     },1000)

    }else{
      this.$router.push({
        name: url,
        query: queryters
      })
   }

}
Vue.prototype.$cookieStore = {setCookie,getCookie,delCookie,checkCookie}
Vue.use(htmlToPdf)
Vue.use(scroll)
Vue.config.productionTip = false

new Vue({
  router,
  components: { Collection },
  store,
  render: h => h(App)
}).$mount('#app')
